import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Api from '../Apis';
import { ExportsNav } from './ExportsNav';
import { AppLoading } from '../Loading';
import { DisplayResults } from '../helper/DisplayResult';
import { DisplayRecords } from '../helper/DisplayRecords';

const BLANK_EXPORT = {
    "price_id": 0,
    "product_name": "",
    "type_name": "",
    "amount_used": 0,
    "quantity_used": 0,
    "action": "",
    "customer": "regular"
};

export const AddExport = () => {

    const timeoutRef = useRef(null);
    const [productComponents,setProductComponents] = useState([])
    const [searchProduct,setSearchProduct] = useState("")
    const [autoRefresh,setAutoRefresh] = useState(true)
    const [loading,setLoading] = useState(false)
    const [returns,setReturns] = useState([])
    const [displayResults,setDisplayResults] = useState(false)
    const [displayRecords,setDisplayRecords] = useState(false)
    const [inputs, setInputs] = useState([{ ...BLANK_EXPORT }]);
    const [currentPage, setCurrentPage] = useState(0);

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedInputs = [...inputs];
        updatedInputs[index] = { ...updatedInputs[index], [name]: value };
        setInputs(updatedInputs);
    };

    const handleProductSelect = (index, event) => {
        const priceId = event.target.value;
        const selected = productComponents.find(comp => String(comp.price_id) === String(priceId));
        const updatedInputs = [...inputs];
        updatedInputs[index] = {
            ...updatedInputs[index],
            price_id: priceId,
            product_name: selected ? selected.product_name : "",
            type_name: selected ? selected.type_name : ""
        };
        setInputs(updatedInputs);
    };

    const addInputGroup = () => {
        setInputs([...inputs, { ...BLANK_EXPORT }]);
        setCurrentPage(inputs.length);
    };

    const removeInputGroup = (index) => {
        const updatedInputs = inputs.filter((_, i) => i !== index);
        setInputs(updatedInputs);
        setCurrentPage(Math.max(0, currentPage - 1));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true)
        // product_name/type_name are only stored for the confirmation display,
        // the API doesn't need them alongside price_id.
        const payload = inputs.map(({ product_name, type_name, ...rest }) => rest);
        axios.post(Api.export.value + "/export/", payload,{headers: Api.Token}).then(res=>{
            setReturns(res.data)
            setDisplayRecords(false)
            setDisplayResults(true)
            setInputs([{ ...BLANK_EXPORT }])
            setCurrentPage(0)
            setSearchProduct("")
            setAutoRefresh(!autoRefresh)
        }).catch((e)=>{
            console.log(e)
            alert("Failed to save data")
        }).finally(()=>setLoading(false))
    };

    const handleCancel = () => {
        setInputs([{ ...BLANK_EXPORT }])
        setCurrentPage(0)
        setDisplayRecords(false)
    }

    const handleKeyPress = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            if(searchProduct && searchProduct.length >2){
                setLoading(true)
                axios.get(Api.products.value + "/getProductsByProductName/" + searchProduct,{headers: Api.Token}).then(res=>{
                    setProductComponents(res.data)
                }).catch((e)=>{
                    console.log(e)
                    alert("Failed to fetch data")
                }).finally(()=>setLoading(false))
            
            }
        }, 2000);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    },[autoRefresh])

    return (
        <div>
            <ExportsNav />
            {displayResults && <DisplayResults returns={returns} setDisplay={setDisplayResults} />}
            {displayRecords && <DisplayRecords
                rows={['product_name', 'type_name', 'quantity_used', 'action', 'customer']}
                inputs={inputs}
                removeInputGroup={removeInputGroup}
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
            />}
            <form onSubmit={(e) => {
                    e.preventDefault()
                    setDisplayRecords(true)
                }
            } className='form was-validated'>
                <div className='mt-2'>
                    <h2 className='text-center'>Export New Products</h2>
                    <div className="row">
                        
                        <div className="col-md-6 bg-light">
                                {inputs && inputs.map((inputGroup, index) => (
                                    index === currentPage && (
                                        <div key={index} >
                                            <div className="row d-flex">
                                                <label className="form-label">Product</label>
                                                    <div>
                                                        <input
                                                            type="text" required
                                                            onChange={e=>setSearchProduct(e.target.value)}
                                                            onKeyUp={handleKeyPress}
                                                            className="form-control"
                                                            
                                                        />
                                                        <select required name="price_id" value={inputGroup.price_id}  onChange={(e) => handleProductSelect(index, e)} className="form-select mt-2" id="">
                                                            <option value="">See results</option>
                                                            {
                                                                productComponents.length > 0? productComponents.map((comp,index) =>(
                                                                    <option key={index} value={comp.price_id}>
                                                                        {comp.product_name}-
                                                                        {comp.type_name}-{comp.quantity_remain}P-
                                                                        {comp.min_price}rwf
                                                                        </option>
                                                                )):<option>no product</option>
                                                            }
                                                        </select>
                                                    </div>
                                                <div className="col-md-6 first_div">
                                                    <label className="form-label">Quantity</label>
                                                    <input required min="1"
                                                        type="number"
                                                        name="quantity_used"
                                                        value={inputGroup.quantity_used}
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        className="form-control"
                                                    />
                                                    
                                                    <input required

                                                        type="radio"
                                                        name="action"
                                                        id='paid'
                                                        value="paid"
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        className="form-radio"
                                                    />
                                                    <label htmlFor='paid' className="form-label">Paid</label>

                                                    <input required min="1"
                                                        type="radio"
                                                        name="action"
                                                        value="credit"
                                                        id='credit'
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        className="form-radio ms-5 mt-3"
                                                    />
                                                    <label htmlFor='credit' className="form-label">Credit</label>
                                                </div>
                                                <div className="col-md-6 second_div">
                                                <label className="form-label">Customer</label>
                                                    <input required min-length="1"
                                                        type="text"
                                                        name="customer"
                                                        value={inputGroup.customer}
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        className="form-control"
                                                    />
                                                    
                                                </div>
                                                
                                            </div>
                                            
                                            <button
                                                type="button"
                                                className="btn btn-danger mt-2"
                                                onClick={() => removeInputGroup(index)}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    )
                                ))}
                                
                            
                        
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-3">
                                    
                                </div>
                                <div className="col-md-6">
                                    <div className=' col-md mt-3 '>
                                        <button type="button" className="btn btn-primary mt-5 w-100" onClick={addInputGroup}>
                                            Add Input Group
                                        </button><br />
                                        <button type="submit" className="btn mt-5 w-100 btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                        
                    </div>
                    <div className="mt-2 pb-2">
                    {inputs.map((_, index) => (
                        <p
                            key={index}
                            className={`btn btn-secondary mx-1`}
                        >
                            {index + 1}
                        </p>
                    ))}</div>
                </div>
            </form>  
            <div style={loading?{display:"block"}:{display:"none"}}>
                <AppLoading />
            </div>          
        </div>
    );
};